import React from 'react'
import styles from '~/styles/atoms/footer/footer.module.scss'

import { agreementPath } from '~/common/define/path'
import { OperatingCompanyUrl } from '~/common/define/url'
import InternalLink from '~/components/atoms/link/InternalLink'
import ExternalLink from '~/components/atoms/link/ExternalLink'
import { IconColor } from '~/components/atoms/icon/Icon'
import { useTranslation } from 'react-i18next'
import { copyRightText } from '~/common/utils/copyright'

const LoginFooter = () => {
  const {t} = useTranslation('login')

  return (
    <footer>
      <ul className={styles.login}>
        <a className={styles.login__item} href={'/'}>
          {t('footer.site')}
        </a>
        <a className={styles.login__item} href={agreementPath()}>
          {t('footer.terms_of_service')}
        </a>
        <ExternalLink className={styles.login__item} link={OperatingCompanyUrl.PRIVACY} mark color={IconColor.GRAY}>
          {t('footer.privacy_policy')}
        </ExternalLink>
      </ul>
      <p className={styles.login__copy}>{copyRightText}</p>
    </footer>
  )
}

export default LoginFooter